export default "__VITE_ASSET__DiggB2zk__"